// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"922a628f","453":"613d2609","455":"a50ad7a3","977":"15496e1e"}[chunkId] + ".chunk.js";
};